import React, { useState, useEffect } from "react";
import { Col, Table, Row, Image, Button, Modal } from "react-bootstrap";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import CustomSuperAdminNotification from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import NewCountDown from "../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import SuperAdminCall from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import isEmpty from "../../../store/validation/is-Empty";
import DeletePopup from "../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import EditWaitTime from "../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import EnterTableNumber from "../../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";
import CallingButtonPopup from "../../reusableComponents/allPopupReusable/CallingButtonPopup";
import ChatWindow from "./seatingDashboard/ChatWindow";
import SendSmsButton from "../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../reusableComponents/allPopupReusable/NotificationButton";
import ViewDinerSendSmsPopup from "./ViewDinerSendSmsPopup";
import ViewDinerNotificationPopup from "./ViewDinerNotificationPopup";
import LocationReusable from "../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import EditDiner from "../../vendorDashboardComponents/seatingDashboard/EditDiner";
import CallingIconButtonActionFile from "../../reusableComponents/allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";

const ViewDiner = (props) => {

  const restData = useSelector((state) => {
    return !isEmpty(state?.onboarding?.restaurantDetails) ? state.onboarding?.restaurantDetails : {};
  });

  //state
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState({
    showMoreDetail: true,
  });
  const [showView, setShowView] = useState(false);
  const handleCloseView = () => setShowView(false);
  const [state, setState] = useState({
    code: "",
  });
  const handleShowView = () => {
    setShowView(true);
  };
  useEffect(() => {
    if (props?.defaultOpen === true) {
      // handleShowView();
    }
    if (props?.setopenViewWhenScan) props.setopenViewWhenScan(false);
  }, [props?.defaultOpen]);
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };

  // const [checkedBox, setCheckedBox] = useState(false);
  // const handleChangeSwitch = (e) =>
  //   setCheckedBox({ checkedBox: !checkedBox.checkedBox });

  /*******************************
   * @DESC Pending Total Wait time
   *******************************/
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dataSend.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convertPending(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  /*******************************
   * @DESC Acceptance time
   *******************************/
  const currentTimeA = new Date(props.dataSend.createdAt);
  var endTimeA = moment(currentTimeA).format("YYYY-MM-DDTHH:mm");
  const acceptanceTime = new Date(props.dataSend.dinerAcceptTime);
  var startTimeA = moment(acceptanceTime).format("YYYY-MM-DDTHH:mm");

  let dateOneA = new Date(startTimeA);
  let dateTwoA = new Date(endTimeA);

  let msDifferenceA = dateOneA - dateTwoA;
  let minutesA = Math.floor(msDifferenceA / 1000 / 60);

  function time_convertAcceptance(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return nMinutesSeated + " min : " + (nMinutesSeated % 60) + "secs";
  }

  /*******************************
   * @DESC Acceptance time
   *******************************/
  const currentTimeC = new Date(props?.dataSend?.seatedTime);
  var endTimeC = moment(currentTimeC).format("YYYY-MM-DDTHH:mm");
  const completionTime = new Date(props?.dataSend?.dinerCompleteTime);
  var startTimeC = moment(completionTime).format("YYYY-MM-DDTHH:mm");

  let dateOneC = new Date(startTimeC);
  let dateTwoC = new Date(endTimeC);

  let msDifferenceC = dateOneC - dateTwoC;
  let minutesC = Math.floor(msDifferenceC / 1000 / 60);

  /*******************************
   * @DESC Seating Total Wait time
   *******************************/
  const seatedTime = new Date(props.dataSend.seatedTime);
  const updatedAt = new Date(props.dataSend.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let dataThreeSeated = new Date(updatedTimeNew);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let totalUpdatedTime = dataThreeSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    console.log(
      "acceptancetime",
      hours + " HH : " + nMinutesSeated + " min" + (nMinutesSeated % 60)
    );
    return hours + " HH : " + nMinutesSeated + " min";
  }

  function upated_time_difference(minutesUpdatedTime) {
    var hours = Math.floor(minutesUpdatedTime / 60);
    var nMinutesUpdatedTime = minutesUpdatedTime % 60;
    return hours + " HH : " + nMinutesUpdatedTime + " min";
  }

  const updatedTime = new Date(
    props.dataSend.wait_time_date || props.dataSend.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNewDiff = updatedTime.getTime();
  const waitTime = props.dataSend.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNewDiff + waitTime;
  let diff = updateWaitTime - currentTimeTwo;
  const [open, setState1] = useState(false);
  const onCloseModal = () => {
    setState1(!open);
  };

  const [enterTableModal, setEnterTableModal] = useState(false);
  const setTablePopUp = (e) => {
    setEnterTableModal(true);
  };
  const setTablePopUpClose = (e) => {
    setEnterTableModal(false);
  };

  useEffect(() => {
    if (props?.enterTableModal) {
      handleCloseView();
    }
  }, [props?.enterTableModal]);

  const [editWaitTimeModel, seteditWaitTimeModel] = useState(false);
  const changeEditWaitTimeModel = () => seteditWaitTimeModel(false);
  const openEditWaitTimeModel = () => seteditWaitTimeModel(true);
  let vendorId = JSON.parse(localStorage.getItem("vendorId"));
  let subscriptionId = JSON.parse(localStorage.getItem("subscriptionId"));

  /*******************************
   * @DESC VIEW ACCEPTANCE TIME
   ******************************/
  const acceptanceTime_calc = (data) => {
    var startTime = moment(data?.createdAt, "DD-MM-YYYY hh:mm:ss").valueOf();
    var endTime = moment(
      data?.dinerAcceptTime,
      "DD-MM-YYYY hh:mm:ss"
    ).valueOf();
    var diff = moment(endTime) - moment(startTime);
    // execution
    let hours = moment.utc(diff).format("HH");
    let minute = moment.utc(diff).format("mm");
    let seconds = moment.utc(diff).format("ss");
    let finalTime = `${hours !== "00" ? `${hours} hours :` : ""
      } ${minute} min : ${seconds} secs`;
    return finalTime;
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => handleShowView()}
      >
        <Image
          src={require("../../../assets/images/UserManagement/eye.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal
        show={showView}
        onHide={() => handleCloseView()}
        centered
        size="lg"
        backdrop="static"
        keyboard="false"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Diner Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div
            className={`enGrayBorderBox ${props.dataSend.service_type === "RESERVATION"
              ? "enLeftYellowLine"
              : "enLeftGReenLine"
              } mb-4`}
          >
            <Row className="px-3">
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Name/Request Number</div>
                <div className="d-flex">
                  <div>
                    {props?.dataSend?.isWalkIn === true &&
                      props?.dataSend?.service_type === "SEATING" ? (
                      <Image
                        src={require("../../../assets/images/ActionImages/image/walkin.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="16px"
                      />
                    ) : null ||
                      (props?.dataSend?.isWalkIn === false &&
                        props?.dataSend?.service_type === "SEATING") ? (
                      <Image
                        src={require("../../../assets/images/ActionImages/image/waitlist.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="16px"
                      />
                    ) : null ||
                      props?.dataSend?.service_type === "RESERVATION" ? (
                      <Image
                        src={require("../../../assets/images/ActionImages/image/reservation.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="16px"
                      />
                    ) : null}
                  </div>
                  <div className="pl-2">
                    <div className="f15-500">
                      {props.dataSend.user_details.name}
                    </div>
                    <div className="f9-400">#{props.dataSend.diner_id}</div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {props.dataSend.adult_count + props.dataSend.kids_count}
                    </p>
                    <div className="adult-total-box-two mr-2">
                      {props.dataSend.adult_count === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../assets/images/ActionImages/employees.png")}
                              fluid
                              alt="Adult"
                              title="Adult"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {props.dataSend.adult_count}
                          </span>
                        </div>
                      )}
                      {props.dataSend.kids_count === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../assets/images/ActionImages/children.png")}
                              fluid
                              alt="Children"
                              title="Children"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {props.dataSend.kids_count}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="adult-total-box-three">
                      {props.dataSend.handicap_chair === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../assets/images/ActionImages/highchair.png")}
                              fluid
                              alt="Highchair"
                              title="Highchair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {props.dataSend.handicap_chair}
                          </span>
                        </div>
                      )}
                      {props.dataSend.high_chair === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../assets/images/ActionImages/wheelchair.png")}
                              fluid
                              alt="Wheel Chair"
                              title="Wheel Chair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {props.dataSend.high_chair}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Date / Time / Timer</div>
                <div className="f18-700 text-red d-flex align-items-center">
                  {props.displayButton === "PENDING" ||
                    props.dataSend.diner_status === "COMPLETED" ||
                    props.dataSend.diner_status === "REJECTED" ||
                    props.dataSend.diner_status === "CANCELLED" ||
                    props.dataSend.diner_status === "SEATED" ? (
                    "00:00:00"
                  ) : (
                    // <NewCountDown waitNew={diff} />
                    <EditWaitTime
                      allDataProps={props.dataSend._id}
                      // noDisplay
                      editButtonStatus={"viewButtonEdit"}
                      waitTimeDiff={diff && diff}
                      openFromParent={changeEditWaitTimeModel}
                      changeEditWaitTimeModel={changeEditWaitTimeModel}
                    />
                  )}
                  {props.displayData === "SUPERADMIN"
                    ? ""
                    : props.displayButton === "PENDING" ||
                      props.dataSend.diner_status === "COMPLETED" ||
                      props.dataSend.diner_status === "REJECTED" ||
                      props.dataSend.diner_status === "CANCELLED" ||
                      props.dataSend.diner_status === "SEATED"
                      ? ""
                      : // <Button
                      //   variant="link"
                      //   className="enIconBtn enSmallIcon ml-1"
                      // >
                      //   <Image
                      //     src={require("../../../assets/images/UserManagement/pencil.svg")}
                      //     alt="Edit"
                      //     title="Edit"
                      //     fluid
                      //   />
                      // </Button>
                      ""}
                </div>
                {/* <div className="f12-400">25th Aug, 2020</div>
                <div className="f12-400">12:15 PM</div> */}
                <p className="f12-400">
                  {props.dataSend.service_type === "RESERVATION"
                    ? moment(props.dataSend.reservationTime).format(
                      "Do MMM YYYY"
                    )
                    : moment(props.dataSend.createdAt).format("Do MMM YYYY")}
                </p>
                <p className="f12-400">
                  {props.dataSend.service_type === "RESERVATION"
                    ? moment(props.dataSend.reservationTime).format("hh:mm A")
                    : moment(props.dataSend.createdAt).format("hh:mm A")}
                </p>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Seating Preference</div>
                <div className="f12-400">
                  {props.dataSend.seating_preference}
                </div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Request Date & Time</div>
                <div className="f12-400">
                  {moment(props.dataSend.createdAt).format("Do MMMM YYYY")}
                </div>
                <div className="f12-400">
                  {moment(props.dataSend.createdAt).format("hh:mm A")}
                </div>
              </Col>
              <Col lg={2} md={6} className="py-3">
                {props.auth !== "vendor" ? (
                  <></>
                ) : (
                  <>
                    <div className="f12-500 pb-3 text-center">
                      Track User
                      <br />
                      Location
                    </div>
                    <div className="">
                      <LocationReusable
                        dataSend={props.dataSend}
                        socket={props.socket}
                        disabled={[
                          "COMPLETED",
                          "CANCELLED",
                          "REJECTED",
                        ].includes(props.dataSend?.diner_status)}
                      />
                    </div>
                  </>
                )}
              </Col>
              <Col lg={4} md={6} className="py-3">
                <p className="f12-400 text-center">Total Wait time</p>
                <div className="d-flex justify-content-center f10-500 align-items-center">
                  {props.displayData === "SUPERADMIN" ? (
                    ""
                  ) : props.displayButton === "PENDING" ? (
                    <div>
                      <DeletePopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        actionCall={"pendingSide"}
                        buttonText="Reject"
                        bigText="Request Reject"
                        reasonText="Are you sure to Reject ?"
                        dataSend={props.dataSend._id}
                        actionBy={props.viewActionPerformBy}
                        pathAction="HISTORY"
                        adminSendVendorId={props.viewVendorId}
                        IconButton={require("../../../assets/images/iconButton/crossred.svg")}
                      />
                    </div>
                  ) : props.displayButton === "HISTORY" ? (
                    <div className="">
                      {props.dataSend.diner_status === "COMPLETED" ||
                        props.dataSend.diner_status === "REJECTED" ? (
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="historyReset"
                          buttonText="Reset"
                          bigText="Request Reset"
                          reasonText="Are you sure to Reset ?"
                          dataSend={props.dataSend}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                        />
                      ) : null || props.dataSend.diner_status === "SEATED" ? (
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="historyUnseated"
                          buttonText="Unseat"
                          bigText="Request Unseat"
                          reasonText="Are you sure to Unseat ?"
                          dataSend={props.dataSend}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                          IconButton={require("../../../assets/images/iconButton/backarrowred.svg")}
                        />
                      ) : null}
                    </div>
                  ) : props.displayButton === "RESERVATION" ? (
                    props.dataSend.diner_status === "SEATED" ? (
                      props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="seatingUnseated"
                            buttonText="Unseat"
                            bigText="Request Unseat"
                            display={true}
                            reasonText="Are you sure to Unseat ?"
                            dataSend={props.dataSend}
                            actionBy={props.viewActionPerformBy}
                            pathAction="HISTORY"
                            adminSendVendorId={props.viewVendorId}
                            IconButton={require("../../../assets/images/iconButton/backarrowred.svg")}
                          />
                        </div>
                      )
                    ) : props.displayInfo === "SUPERADMIN" ? (
                      ""
                    ) : (
                      <div>
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall={"seatingDashboardSide"}
                          buttonText="Cancel"
                          bigText="Request Cancel"
                          reasonText="Are you sure to Cancel ?"
                          dataSend={props.dataSend._id}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                          IconButton={require("../../../assets/images/iconButton/crossred.svg")}
                        />
                      </div>
                    )
                  ) : props.displayButton === "SEATING" ? (
                    props.dataSend.diner_status === "SEATED" ? (
                      props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="seatingUnseated"
                            buttonText="Unseat"
                            bigText="Request Unseat"
                            display={true}
                            reasonText="Are you sure to Unseat ?"
                            dataSend={props.dataSend}
                            subscription_id={props.subscription_id}
                            actionBy={props.viewActionPerformBy}
                            pathAction="HISTORY"
                            adminSendVendorId={props.viewVendorId}
                            IconButton={require("../../../assets/images/iconButton/backarrowred.svg")}
                          />
                        </div>
                      )
                    ) : props.displayInfo === "SUPERADMIN" ? (
                      ""
                    ) : (
                      <div>
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall={"seatingDashboardSide"}
                          buttonText="Cancel"
                          bigText="Request Cancel"
                          reasonText="Are you sure to Cancel ?"
                          dataSend={props.dataSend._id}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                        />
                      </div>
                    )
                  ) : (
                    ""
                  )}
                  <div className="px-2">
                    <div className="enTimesLbl d-flex justify-content-center align-items-center">
                      <Image
                        src={require("../../../assets/images/UserManagement/hourglass.svg")}
                        alt="Edit"
                        title="Edit"
                        width="10px"
                      />
                      <p className="f10-500 text-dark pl-2">
                        {" "}
                        {props.dataSend.diner_status === "PENDING" ||
                          props.dataSend.diner_status === "NOTSEATED"
                          ? time_convertPending(minutes)
                          : props.dataSend.diner_status === "SEATED" ||
                            props.dataSend.diner_status === "COMPLETED"
                            ? seated_time_difference(minutesSeated)
                            : props.dataSend.diner_status === "REJECTED" ||
                              props.dataSend.diner_status === "CANCELLED"
                              ? upated_time_difference(minutesUpdatedTime)
                              : null}
                      </p>
                    </div>
                  </div>
                  {props.displayData === "SUPERADMIN" ? (
                    ""
                  ) : props.displayButton === "PENDING" ? (
                    <div>
                      {props.dataSend.service_type === "RESERVATION" ? (
                        props.dataSend.service_type === "RESERVATION" &&
                          moment(props?.date3).unix() <
                          moment(props?.date1).unix() ? (
                          ""
                        ) : (
                          <DeletePopup
                            buttonDisplay="acceptButtonReservation"
                            buttonText="Accept"
                            bigText="Request Accept"
                            reasonText="Are you sure you want to accept ?"
                            dataSend={props.dataSend}
                            actionBy={props.viewActionPerformBy}
                            pathAction="HISTORY"
                            adminSendVendorId={props.viewVendorId}
                          />
                        )
                      ) : props.dataSend.service_type === "SEATING" &&
                        moment(props?.date2).format("DD") <
                        moment(props?.date1).format("DD") ? (
                        ""
                      ) : (
                        <EditWaitTime
                          buttonText="Accept"
                          editButtonStatus="pendingEdit"
                          closedMainModal={props.onCloseModal}
                          allDataProps={props.dataSend._id}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                        />
                      )}
                    </div>
                  ) : props.displayButton === "HISTORY" ? (
                    <div>
                      {props.dataSend.diner_status === "SEATED" ? (
                        <DeletePopup
                          buttonDisplay="smallSaveButton"
                          displayPopup="historyCompleted"
                          buttonText="Complete"
                          bigText="Request Complete"
                          reasonText="Are you sure to Completed ?"
                          dataSend={props.dataSend}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                          IconButton={require("../../../assets/images/iconButton/Nextarrowgreen.svg")}
                        />
                      ) : null}
                    </div>
                  ) : props.displayButton === "RESERVATION" ? (
                    moment(new Date()).format("YYYY-MM-DD") >=
                      moment(props.dataSend.reservationTime).format(
                        "YYYY-MM-DD"
                      ) ? (
                      props.dataSend.diner_status === "SEATED" ? (
                        props.displayInfo === "SUPERADMIN" ? (
                          ""
                        ) : (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Request Completed"
                              reasonText="Are you sure to Completed ?"
                              // bigText="Are you sure to Completed ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                              IconButton={require("../../../assets/images/iconButton/Nextarrowgreen.svg")}
                            />
                          </div>
                        )
                      ) : props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          <EnterTableNumber
                            buttonText="Seat"
                            enterTableModal={enterTableModal}
                            closedMainModal={onCloseModal}
                            setTablePopUp={setTablePopUp}
                            setTablePopUpClose={setTablePopUpClose}
                            allDataProps={props.dataSend?._id}
                            wholeDataObj={props.dataSend}
                            IconButton={require("../../../assets/images/iconButton/Nextarrowgreen.svg")}
                          />
                        </div>
                      )
                    ) : null
                  ) : props.displayButton === "SEATING" ? (
                    props.dataSend.diner_status === "SEATED" ? (
                      props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="seatingCompleted"
                            displayPopup="seatingCompleted"
                            buttonText="Complete"
                            bigText="Request Complete"
                            reasonText="Are you sure to Completed ?"
                            dataSend={props.dataSend}
                            subscription_id={props.subscription_id}
                            actionBy={props.viewActionPerformBy}
                            pathAction="HISTORY"
                            adminSendVendorId={props.viewVendorId}
                            IconButton={require("../../../assets/images/iconButton/Nextarrowgreen.svg")}
                          />
                        </div>
                      )
                    ) : props.displayInfo === "SUPERADMIN" ? (
                      ""
                    ) : moment().format() >=
                      moment(props.dataSend.reservationTime).format() ? (
                      <div>
                        {/* <DeletePopup
                      buttonDisplay="smallSaveButton"
                      displayPopup="SeatedButton"
                      buttonText="Seat"
                      bigText="Request Seated"
                      reasonText="Are you sure to Seated ?"
                      dataSend={props.dataSend._id}
                    /> */}

                        <button
                          className="n_button_d_status font_18_m popup-save-button"
                          type="button"
                          onClick={(e) => props?.setEnterTableModalProp(true)}
                        >
                          Seat
                        </button>
                        {/* <EnterTableNumber
                          buttonText="Seat"
                          closedMainModal={props.onCloseModal}
                          allDataProps={props.dataSend._id}
                          actionBy={props.viewActionPerformBy}
                          pathAction="HISTORY"
                          adminSendVendorId={props.viewVendorId}
                        /> */}
                      </div>
                    ) : (
                      <button
                        className="n_button_d_status font_18_m popup-save-button"
                        type="button"
                        onClick={(e) => props?.setEnterTableModalProp(true)}
                      >
                        Seat
                      </button>
                      // <EnterTableNumber
                      //   buttonText="Seat"
                      //   closedMainModal={props.onCloseModal}
                      //   allDataProps={props.dataSend._id}
                      //   actionBy={props.viewActionPerformBy}
                      //   pathAction="HISTORY"
                      //   adminSendVendorId={props.viewVendorId}
                      //   // disabled={true}
                      // />
                    )
                  ) : (
                    ""
                  )}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                {props.dataSend.diner_status !== "REJECTED" && (
                  <>
                    <p className="f12-400 text-center">
                      {props?.dataSend?.diner_status === "NOTSEATED" ||
                        props?.dataSend?.diner_status === "SEATED" ||
                        props?.dataSend?.diner_status === "COMPLETED" ||
                        props?.dataSend?.diner_status === "PENDING"
                        ? "Acceptance"
                        : props?.dataSend?.diner_status === "CANCELLED"
                          ? "Cancellation"
                          : props?.dataSend?.diner_status === "Rejected"
                            ? "Rejected"
                            : ""}{" "}
                      Time
                    </p>
                    <div className="px-2" align="center">
                      <div className="enTimesLbl d-flex justify-content-center align-items-center">
                        <Image
                          src={require("../../../assets/images/UserManagement/hourglass.svg")}
                          alt="Edit"
                          title="Edit"
                          width="10px"
                        />
                        <p className="f10-500 text-dark pl-2">
                          {/* {isNaN(time_convertAcceptance(minutesA))
                            ? `0 min : 0 secs`
                            : time_convertAcceptance(minutesA)} */}
                          {props?.dataSend?.dinerAcceptTime !== null &&
                            props?.dataSend?.dinerAcceptTime !== undefined
                            ? acceptanceTime_calc(props?.dataSend)
                            : `0 min : 0 secs`}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                {props.dataSend.diner_status === "COMPLETED" &&
                  props?.dataSend?.dinerCompleteTime && (
                    <>
                      <p className="f12-400 text-center pt-1">
                        Completion Time
                      </p>
                      <div className="px-2" align="center">
                        <div className="enTimesLbl d-flex justify-content-center align-items-center">
                          <Image
                            src={require("../../../assets/images/UserManagement/hourglass.svg")}
                            alt="Edit"
                            title="Edit"
                            width="10px"
                          />
                          <p className="f10-500 text-dark pl-2">
                            {props.dataSend.diner_status === "PENDING" ||
                              props.dataSend.diner_status === "NOTSEATED"
                              ? seated_time_difference(minutesC)
                              : props.dataSend.diner_status === "SEATED" ||
                                props.dataSend.diner_status === "COMPLETED"
                                ? seated_time_difference(minutesC)
                                : props.dataSend.diner_status === "REJECTED" ||
                                  props.dataSend.diner_status === "CANCELLED"
                                  ? seated_time_difference(minutesC)
                                  : null}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">
                  Membership Card
                  <br />
                  Details
                </div>
                <div className="f12-400">
                  Type -
                  <br />
                  No. -
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Table / Room No.</div>
                <div className="f12-400">
                  {props?.dataSend?.table_number === null ||
                    props?.dataSend?.table_number === undefined ||
                    props?.dataSend?.table_number === ""
                    ? ""
                    : `Table No. - ${props?.dataSend?.table_number}`}
                </div>
                <div className="f12-400">
                  {props?.dataSend?.room_number === null ||
                    props?.dataSend?.room_number === undefined ||
                    props?.dataSend?.room_number === ""
                    ? ""
                    : `Room No. - ${props?.dataSend?.room_number}`}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Special Occasion</div>
                <div className="f12-400" style={{ wordBreak: "break-word" }}>
                  {props.dataSend.occasion}
                </div>
                {/* <Button variant="link" className="text-red f12-400 p-0">
                  See more
                </Button> */}
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="f13-400">
                  <span className="enYellowDot mr-1"></span>
                  {props.dataSend.diner_status}
                </div>
              </Col>
            </Row>
            <hr />
            <div className="d-flex flex-wrap justify-content-center align-items-center py-3 ">
              {/* <div className="d-flex"> */}
              <div className="mb-3">
                {/* <CallingButtonPopup
                  buttonClass="smallButton"
                  sendData={props.dataSend}
                /> */}
                <CallingIconButtonActionFile
                  orderDetails={props?.dataSend?.user_details}
                  actionType="conbinedName"
                />
              </div>
              <div className="mb-3">
                <ViewDinerSendSmsPopup
                  mobile_number={
                    props.dataSend.user_details.country_code +
                    props.dataSend.user_details.mobile_number
                  }
                  diner_id={props.dataSend._id}
                />
              </div>
              <div className="mb-3">
                <ViewDinerNotificationPopup
                  buttonClass="smallButton"
                  dataSend={props.dataSend}
                />
              </div>
              {/* </div> */}
              <div className="mb-3">
                <ChatWindow data={props.dataSend} text={props.actionByData} />
              </div>
              <div className="mb-3">
                {/* <EditDiner
                      buttonClass="smallButton"
                      dataSend={props.dataSend}
                      bigText="Edit Diner"
                      displayData={props.displayData}
                      displayButton="RESERVATION"
                      viewActionPerformBy={props.viewActionPerformBy}
                      viewVendorId={vendorId}
                      subscription_id={
                        props.actionPerformBy === "ADMIN"
                          ? subscriptionId
                          : props.subscription_id
                      }
                    /> */}
                {props.displayEdit ? (
                  <></>
                ) : (
                  <EditDiner
                    buttonClass="smallButton"
                    dataSend={props.dataSend}
                    bigText="Edit Diner"
                    displayButton={props.displayButton}
                    onCloseModal={props.onCloseModal}
                    viewActionPerformBy={props.viewActionPerformBy}
                    viewVendorId={vendorId}
                    socket={props.socket}
                    subscription_id={
                      props.actionPerformBy === "ADMIN"
                        ? subscriptionId
                        : props.subscription_id
                    }
                    diff={props?.diff}
                    changeEditWaitTimeModel={props.changeEditWaitTimeModel}
                  />
                )}
              </div>
            </div>
          </div>
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              Details
              {/* <Image
                src={require("../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              /> */}
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-3">
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f15-700 pb-3">
                    {(restData?.userDetails && moment(restData?.userDetailsDate).isBefore(props?.dataSend?.createdAt)) ? props.dataSend.user_details.mobile_number : props.dataSend.user_details.mobile_number.replace(
                      /\d(?=\d{3})/g,
                      "*"
                    )}
                    {/* props.dataSend.user_details.country_code + " " +  */}
                  </div>
                </Col>
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Request Number</div>
                  <div className="f15-700 pb-3">#{props.dataSend.diner_id}</div>
                </Col>
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">User status</div>
                  <div className="f15-700 pb-3">
                    {props?.dataSend?.userConfirmed
                      ? "Confirmed"
                      : "Not Confirmed"}
                  </div>
                </Col>
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Requested date/time</div>
                  <div className="f15-700">
                    {props.dataSend.service_type === "SEATING"
                      ? ""
                      : moment(props.dataSend.reservationTime).format(
                        "Do MMMM YYYY"
                      )}
                  </div>
                  <div className="f15-700">
                    {props.dataSend.service_type === "SEATING"
                      ? ""
                      : moment(props.dataSend.reservationTime).format(
                        "hh:mm A"
                      )}
                  </div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Created date/time</div>
                  <div className="f15-700">
                    {moment(props.dataSend.createdAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f15-700">
                    {moment(props.dataSend.createdAt).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Changed date/time</div>
                  <div className="f15-700">
                    {moment(props.dataSend.updatedAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f15-700">
                    {moment(props.dataSend.updatedAt).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Point of entry</div>
                  <div className="f15-700">{props.dataSend.pointOfEntry}</div>
                </Col>
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Reason for cancellation</div>
                  <div className="f15-700">{props.dataSend.cancelReason}</div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          {/* <div className="enGrayBorderBox">
            <Row className="px-3">
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Transaction ID</div>
                <div className="f15-700 pb-3">-</div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Payment Method</div>
                <div className="f15-700 pb-3">-</div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Payment Status</div>
                <div className="f15-700 pb-3">-</div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Payment Date / Time</div>
                <div className="f15-700 pb-3">
                  {" "}
                  -{/* {moment(new Date()).format("Do MMMM YYYY")} *
                </div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Amount</div>
                <div className="f15-700">-</div>
              </Col>
            </Row>
          </div> 
          <hr />*/}
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(props.dataSend.auditLogs) &&
                    props.dataSend.auditLogs.map((data, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>
                              <div className="f12-500">
                                {moment(data.timestamp).format("Do-MMM-YYYY")}
                              </div>
                              <div className="f12-500">
                                {moment(data.timestamp).format("hh:mm A")}
                              </div>
                            </td>
                            <td>
                              <div className="f12-500">{data.message}</div>
                            </td>
                            <td>
                              <div className="f12-500">{data.initiator}</div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default ViewDiner;
